/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StartAgentResponse
 */
export interface StartAgentResponse {
  /**
   *
   * @type {string}
   * @memberof StartAgentResponse
   */
  agentTaskRunId: string;
}

/**
 * Check if a given object implements the StartAgentResponse interface.
 */
export function instanceOfStartAgentResponse(
  value: object,
): value is StartAgentResponse {
  if (!("agentTaskRunId" in value) || value["agentTaskRunId"] === undefined)
    return false;
  return true;
}

export function StartAgentResponseFromJSON(json: any): StartAgentResponse {
  return StartAgentResponseFromJSONTyped(json, false);
}

export function StartAgentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StartAgentResponse {
  if (json == null) {
    return json;
  }
  return {
    agentTaskRunId: json["agentTaskRunId"],
  };
}

export function StartAgentResponseToJSON(json: any): StartAgentResponse {
  return StartAgentResponseToJSONTyped(json, false);
}

export function StartAgentResponseToJSONTyped(
  value?: StartAgentResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    agentTaskRunId: value["agentTaskRunId"],
  };
}
